import { type SerializedCompStructure } from '@wix/document-services-types'

import {
  type DataBindingConnectionConfigByRole,
  type DataBindingController,
  type DataBindingRole,
} from '../types'
import { assertNonNullable } from './assertNonNullable'
import { getControllerConnectionConfig } from './getControllerConnectionConfig'
import { getControllerConnectionsToComponent } from './getControllerConnectionsToComponent'
import { setComponentConnectionConfigs } from './setComponentConnectionConfigs'
import { setControllerConnectionConfigs } from './setControllerConnectionConfigs'
import { setControllerConnectionsToComponent } from './setControllerConnectionsToComponent'

export const modifyComponentAndControllerConnectionConfig = <
  Role extends DataBindingRole,
>({
  component,
  controller,
  role,
  modifyConnectionConfig,
}: {
  component: SerializedCompStructure
  controller: DataBindingController
  role: Role
  modifyConnectionConfig: (
    config: DataBindingConnectionConfigByRole[Role],
  ) => DataBindingConnectionConfigByRole[Role]
}): {
  component: SerializedCompStructure
  controller: DataBindingController
} => {
  assertNonNullable(component.id)
  const connections = getControllerConnectionsToComponent({
    controller,
    componentId: component.id,
  })
  const config = getControllerConnectionConfig({ connections, role })

  const modifiedConfig = modifyConnectionConfig(config)
  const modifiedConfigByRole = { [role]: modifiedConfig }

  const modifiedComponent = setComponentConnectionConfigs({
    component,
    configByRole: modifiedConfigByRole,
  })

  const modifiedConnections = setControllerConnectionConfigs({
    connections: connections,
    configByRole: modifiedConfigByRole,
  })
  const modifiedController = setControllerConnectionsToComponent({
    controller,
    componentId: component.id,
    connections: modifiedConnections,
  })

  return { component: modifiedComponent, controller: modifiedController }
}
